export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // Search form
    const searchOffersForm = $('.search-offers');
    if (searchOffersForm.length) {
      const submitButton = searchOffersForm.find('button[type="submit"]');

      searchOffersForm.find('.where, .offer')
        .on('input', function() {
          const _this = $(this);

          if (_this.val().length === 0) {
            submitButton.prop('disabled', false);
          } else {
            submitButton.prop('disabled', true);
          }
        })
        .on('input_changed.rsd-ac', function() {
          submitButton.prop('disabled', false);
        });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalOffersPage.js